// @ts-ignore
import SwiperSlider from '@/components/swiper-slider';

export const initSliderCards = (wrapper: HTMLElement): void => {
    const sliderWrapper = wrapper.querySelector('.j-slider-cards') as HTMLElement;
    const nextEl = wrapper.querySelector('.j-slider-cards__next');
    const prevEl = wrapper.querySelector('.j-slider-cards__prev');
    const pagination = wrapper.querySelector('.j-slider-cards__pagination');

    const settings = {
        wrapperClass : 'j-slider-cards__slides',
        slideClass   : 'j-slider-cards__slide',
        slidesPerView: 'auto',
        loop         : false,
        navigation   : {
            nextEl,
            prevEl
        },
        pagination: {
            el       : pagination,
            clickable: true
        }
    };

    const slider = new SwiperSlider({
        item: sliderWrapper,
        settings
    });

    slider.init();
};

